/**
 * Number of pixels on an axis to account for a margin on a grid item
 * So for a margin of 3px, this value is twice the value (L+R or T+B) (as of 20220301) #liveOutline
 */
export default 6;
